@import 'apps/webcomponents/src/assets/scss/mixins';

:host {
  display: block;
  width: auto;
}

:host([disabled]) {
  button {
    color: var(--grey-layout-200-disabled);
    border: 1px solid var(--grey-layout-200-disabled);
    user-select: none;
    &:focus {
      color: var(--grey-layout-200-disabled);
      border: 1px solid var(--grey-layout-200-disabled);
      background-color: var(--white-layout-301-level-0-elevation);
      user-select: none;
    }
  }
}

:host([selected][disabled]) {
  button {
    color: var(--white-layout-250-disabled-text-on-blue-background);
    background-color: var(--blue-layout-200-disabled);
    border: 1px solid transparent;
    user-select: none;
    &:focus {
      color: var(--white-layout-250-disabled-text-on-blue-background);
      background-color: var(--blue-layout-200-disabled);
      border: 1px solid transparent;
      user-select: none;
    }
  }
}

:host([selected]) {
  button {
    background-color: var(--blue-layout-403-primary);
    color: var(--white-layout-201-secondary-on-dark-background);
    border: 1px solid var(--blue-layout-403-primary);
    &:hover {
      background-color: var(--blue-layout-301-active);
      border: 1px solid var(--blue-layout-301-active);
    }
    &:active {
      background-color: var(--blue-layout-501-focus);
      border: 1px solid var(--blue-layout-501-focus);
    }
    &:focus {
      background-color: var(--blue-layout-501-focus);
      border: 1px solid var(--blue-layout-501-focus);
    }
  }
}

:host([invalid]) {
  button {
    border-color: var(--red-layout-300-primary);
  }
}

.multiselect-group {
  display: flex;
}

button {
  border: 1px solid var(--chart-101-pressed-dividers);
  border-radius: var(--input-border-radius);
  background-color: var(--white-layout-301-level-0-elevation);
  color: var(--body-text-arrows-400);
  cursor: pointer;
  font-size: var(--body-size);
  padding: var(--spacer) calc(var(--spacer) * 1.5);
  transition: all 0.3s ease;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  position: relative;

  &:hover {
    background-color: var(--chart-051-hover);
    border: 1px solid var(--main-titles-inputs-600);
  }

  &:active {
    background-color: var(--focus-bg-color);
  }

  &:focus {
    outline: none;
    background-color: var(--focus-bg-color);
    border: 1px solid var(--blue-layout-501-focus);
    @include focus-outline-state-mixin(var(--blue-layout-500-focus), var(--input-border-radius));
  }
}
